"use client";

import { Command } from "cmdk";
import type { ReactNode } from "react";
import { useCommand } from "~/app/[lang]/command/Context";

export function CommandDialog({ children }: { children: ReactNode }) {
	const { open, onOpenChangeHandler } = useCommand();

	return (
		<Command.Dialog
			open={open}
			onOpenChange={onOpenChangeHandler}
			label="Global Command Menu"
			overlayClassName="fixed inset-0 z-dialog bg-shades-dark/25 rdx-state-open:animate-fadeIn rdx-state-closed:animate-fadeOut"
			contentClassName="fixed bottom-[env(safe-area-inset-bottom,0px)] z-dialog max-h-[calc(100%-2rem)] w-full rounded-t bg-white p-4 shadow-lg rdx-state-open:animate-mobileDialogIn rdx-state-closed:animate-mobileDialogOut sm:max-w-xl sm:rounded-b sm:-translate-y-1/2 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:w-[calc(100%-2rem)] sm:rdx-state-open:animate-dialogIn sm:rdx-state-closed:animate-dialogOut sm:origin-top-left"
		>
			{children}
		</Command.Dialog>
	);
}
